export default {
  fraud: {
    fraud: "사기",
    map: "지도",
    caseSummary: "Case Summary",
    workflow: "Workflow",
    caseDetail: "Case Detail",
    networkInformation: "Network Information",
    investigationWorkbench: "Investigation Workbench",
    investigationHistory: "Investigation History",
  }
};
